module.exports = __webpack_public_path__ + "img/garbage.51df33b1.png";